import * as Yup from "yup";

const precificacaoValidator = Yup.array().of(
  Yup.object().shape({
    produtoId: Yup.number().required("ProdutoId"),
    precoCompra: Yup.number().nullable(),
    comissao: Yup.number().nullable(),
    precoCusto: Yup.number().nullable(),
    precoMedio: Yup.number().nullable(),
    precoVenda: Yup.number().required(),
    aliquotas: Yup.array().of(
      Yup.object().shape({
        parametroAliquotaId: Yup.number().required("ParametroId"),
        valor: Yup.number().required("Valor"),
      })
    ),
  })
);

export default precificacaoValidator;
